module.exports=[
  {
    "nom": "L’Entracte",
    "adresse": "16 rue Saint Denis",
    "codepostal": 72300,
    "ville": "Sablé sur Sarthe",
    "www": "http://www.lentracte-sable.fr",
    "mail": "",
    "telephone": "0243622220",
    "type": "Scène conventionnée",
    "conventionnement": "Art en territoire",
    "licence": "2-1107999\n2-1107156\n3-1108000",
    "reseaux": "Réseau des Scènes Départementales\nJeune Public de la Sarthe",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": 3,
    "aidecreation_coprod": 2,
    "aidecreation_residence": 0,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Rock Ici Momes",
    "diffusion_total": 21,
    "diffusion_jp": 7,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 3,
    "diffusion_places_jp": 2677,
    "diffusion_departement": 72,
    "diffusion_epci": 247200090,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      47.83877955,
      -0.338394193437314
    ]
  },
  {
    "nom": "Théâtre du Passeur",
    "adresse": "88 rue de la Rivière",
    "codepostal": 72000,
    "ville": "Le Mans",
    "www": "www theatredupasseur.fr",
    "mail": "",
    "telephone": "0243766582",
    "type": "Compagnie",
    "conventionnement": "",
    "licence": "2-142061",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Les Ptites Goules",
    "diffusion_total": 25,
    "diffusion_jp": 20,
    "diffusion_0_3ans": 6,
    "diffusion_3_6ans": 7,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 1250,
    "diffusion_departement": 72,
    "diffusion_epci": 200068963,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 200068963,
    "actionculturelle_commune": "",
    "coords": [
      48.0099932,
      0.2118187
    ]
  },
  {
    "nom": "Ville de Changé",
    "adresse": "Service culturel, hôtel de ville, 6 place Christian d'Elva",
    "codepostal": 53810,
    "ville": "Changé",
    "www": "http://www.culture-change53.fr",
    "mail": "culture@mairie-change.fr",
    "telephone": "0243533442",
    "type": "Commune",
    "conventionnement": "",
    "licence": "1-1094272\n2-1094273\n3-1094274\n1-1119298",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 19,
    "diffusion_jp": 4,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 1,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 850,
    "diffusion_departement": 53,
    "diffusion_epci": 245300330,
    "diffusion_commune": 53054,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 53,
    "actionculturelle_epci": 245300330,
    "actionculturelle_commune": 53054,
    "coords": [48.0986184,-0.7909365]
  },
  {
    "nom": "Superforma",
    "adresse": "5 place Paul Cézanne",
    "codepostal": 72100,
    "ville": "Le Mans",
    "www": "https://superforma.fr/",
    "mail": "charlene.parrassin@superforma.fr",
    "telephone": "0243145531",
    "type": "Association",
    "conventionnement": "",
    "licence": "2-1101338\n3-1101339",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 100,
    "diffusion_jp": 10,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 10,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 2600,
    "diffusion_departement": 72,
    "diffusion_epci": 247200132,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200132,
    "actionculturelle_commune": "",
    "coords": [
      47.9740307,
      0.215191
    ]
  },
  {
    "nom": "Le Kiosque, centre d'action culturelle de Mayenne Communauté",
    "adresse": "7 Place Juhel",
    "codepostal": 53100,
    "ville": "Mayenne",
    "www": "http://www.croqlesmotsmarmot.org",
    "mail": "melissa.rouzier@mayennecommunaute.fr",
    "telephone": "0243302121",
    "type": "Association",
    "conventionnement": "",
    "licence": "3-1022330\n2-1022328",
    "reseaux": "Quand les livres relient",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 20,
    "aidecreation_coprod": 1,
    "aidecreation_residence": 1,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Croq'les mots, marmot !",
    "diffusion_total": "",
    "diffusion_jp": "",
    "diffusion_0_3ans": "",
    "diffusion_3_6ans": "",
    "diffusion_6_12ans": "",
    "diffusion_12ans": "",
    "diffusion_places_jp": "",
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      48.3025635,
      -0.619756111042693
    ]
  },
  {
    "nom": "Théâtre la Fleuriaye",
    "adresse": "30 Boulevard Ampère",
    "codepostal": 44470,
    "ville": "Carquefou",
    "www": "http://www.theatre-carquefou.fr",
    "mail": "billetterie@mairie-carquefou.fr",
    "telephone": "0228222424",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": "",
    "diffusion_jp": "",
    "diffusion_0_3ans": "",
    "diffusion_3_6ans": "",
    "diffusion_6_12ans": "",
    "diffusion_12ans": "",
    "diffusion_places_jp": "",
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400404,
    "actionculturelle_commune": 44470,
    "coords": [
      47.3003928,
      -1.5005153
    ]
  },
  {
    "nom": "Théâtre La Ruche",
    "adresse": "8 rue Félibien",
    "codepostal": 44000,
    "ville": "Nantes",
    "www": "http://www.laruchenantes.fr",
    "mail": "contact@laruchenantes.fr",
    "telephone": "0251808913",
    "type": "Théâtre privé",
    "conventionnement": "",
    "licence": "1-1087794\n2-1087795\n3-1087796",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 60,
    "diffusion_jp": 7,
    "diffusion_0_3ans": 3,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 1,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 500,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": 44109,
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      47.2209017,
      -1.5638617
    ]
  },
  {
    "nom": "Espace culturel Sainte Anne",
    "adresse": "Mairie, 1 rue de Kerio",
    "codepostal": 44410,
    "ville": "Saint Lyphard",
    "www": "http://www.mairie-saintlyphard.fr",
    "mail": "",
    "telephone": "0240914967",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "1-1004785\n2-1004786\n3-1004787",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": 1,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 21,
    "diffusion_jp": 8,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 5,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 2378,
    "diffusion_departement": 44,
    "diffusion_epci": 244400610,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400610,
    "actionculturelle_commune": 44175,
    "coords": [47.4001841,-2.3086974]
  },
  {
    "nom": "Le Champilambart - Espace Culturel de la Ville de Vallet",
    "adresse": "13 route des Dorices",
    "codepostal": 44330,
    "ville": "Vallet",
    "www": "http://www.champilambart.fr",
    "mail": "",
    "telephone": "0240364281",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": 1078416,
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 2,
    "aidecreation_coprod": 1,
    "aidecreation_residence": 2,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Cep Party / Festival jeune public à Vallet et au Pays du Vignoble Nantais",
    "diffusion_total": 40,
    "diffusion_jp": 14,
    "diffusion_0_3ans": 3,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 5,
    "diffusion_12ans": 3,
    "diffusion_places_jp": 7500,
    "diffusion_departement": 44,
    "diffusion_epci": "200067635 200067866",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": "200067635 200067866",
    "actionculturelle_commune": "",
    "coords": [
      47.1674537,
      -1.2656014
    ]
  },
  {
    "nom": "Pannonica / Association Nantes Jazz Action",
    "adresse": "9, rue Basse Porte",
    "codepostal": 44000,
    "ville": "Nantes",
    "www": "http://www.pannonica.com/site/",
    "mail": "",
    "telephone": "0251838706",
    "type": "Scène conventionnée",
    "conventionnement": "Musiques actuelles",
    "licence": "1-1051970\n2-144432\n3-144433",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 60,
    "diffusion_jp": 4,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 2540,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": 44109,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400404,
    "actionculturelle_commune": "",
    "coords": [
      47.2209624,
      -1.558229
    ]
  },
  {
    "nom": "Le Dôme - Saumur Val de Loire",
    "adresse": "Place Bilange",
    "codepostal": 49400,
    "ville": "SAUMUR",
    "www": "http://saisonculturelle.agglo-saumur.fr/",
    "mail": "mediation.ledome@agglo-saumur.fr",
    "telephone": "0253935005",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": 11071782,
    "reseaux": "PJP49",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 2,
    "aidecreation_coprod": 1,
    "aidecreation_residence": 1,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Mômes en folie et Rancarts des Bambins",
    "diffusion_total": 48,
    "diffusion_jp": 10,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 4,
    "diffusion_6_12ans": 5,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 2000,
    "diffusion_departement": 49,
    "diffusion_epci": 244900361,
    "diffusion_commune": 49400,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 49,
    "actionculturelle_epci": 244900361,
    "actionculturelle_commune": 49400,
    "coords": [
      47.2609457,
      -0.0771268
    ]
  },
  {
    "nom": "Ville de Saint-Sébastien-sur-Loire",
    "adresse": "Hôtel de Ville. Place Marcellin Verbe",
    "codepostal": 44230,
    "ville": "Saint-Sébastien-sur-Loire",
    "www": "http://www.saintsebastien.fr",
    "mail": "",
    "telephone": "0240808513",
    "type": "Service Culturel",
    "conventionnement": "",
    "licence": "1-1112509\n1-1112510\n1-1112512\n1-1112513",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "La Loire cool, l'été à Saint-Sébastien",
    "diffusion_total": 80,
    "diffusion_jp": 20,
    "diffusion_0_3ans": 5,
    "diffusion_3_6ans": 5,
    "diffusion_6_12ans": 10,
    "diffusion_12ans": 50,
    "diffusion_places_jp": 1200,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": 44230,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400404,
    "actionculturelle_commune": 44230,
    "coords": [
      47.2059475,
      -1.5019173410701
    ]
  },
  {
    "nom": "Maison de Quartier le Trois-Mâts",
    "adresse": "Place des Justices BP51445",
    "codepostal": 49014,
    "ville": "Angers",
    "www": "http://www.letroismats.fr",
    "mail": "",
    "telephone": "0241660202",
    "type": "Maison de Quartier",
    "conventionnement": "",
    "licence": "1-1094269\n2-1094270\n3-1094271",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 2,
    "aidecreation_coprod": 2,
    "aidecreation_residence": 2,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Semaine ou Mois de la petite enfance",
    "diffusion_total": 18,
    "diffusion_jp": 5,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 1,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 750,
    "diffusion_departement": 49,
    "diffusion_epci": 244900015,
    "diffusion_commune": 49007,
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 49,
    "actionculturelle_epci": 244900015,
    "actionculturelle_commune": 49007,
    "coords": [47.4530144,-0.5278988]
  },
  {
    "nom": "Le Quatrain",
    "adresse": "rue de la Basse Lande",
    "codepostal": 44115,
    "ville": "Haute-Goulaine",
    "www": "https://www.lequatrain.fr/",
    "mail": "",
    "telephone": "0240806603",
    "type": "Espace culturel",
    "conventionnement": "",
    "licence": "1-103552\n2-103553\n3-103554",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": 1,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 29,
    "diffusion_jp": 6,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 3139,
    "diffusion_departement": 44,
    "diffusion_epci": 200067635,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 200067635,
    "actionculturelle_commune": "",
    "coords": [
      47.1920402,
      -1.4410264
    ]
  },
  {
    "nom": "Festival Ça Chauffe",
    "adresse": "37 route de Nantes",
    "codepostal": 49610,
    "ville": "Mûrs-Erigné",
    "www": "https://www.festival-chauffe.fr",
    "mail": "",
    "telephone": "0241578185",
    "type": "Festival",
    "conventionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Festival Ça Chauffe",
    "diffusion_total": 20,
    "diffusion_jp": 10,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 6,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 2100,
    "diffusion_departement": 49,
    "diffusion_epci": 244900015,
    "diffusion_commune": 49223,
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      47.4009957,
      -0.5406705
    ]
  },
  {
    "nom": "Le TNT",
    "adresse": "11 allée de la maison rouge",
    "codepostal": 44000,
    "ville": "Nantes",
    "www": "http://www.tntheatre.com",
    "mail": "contact@tntheatre.com",
    "telephone": "0240121228",
    "type": "Scène de découvertes",
    "conventionnement": "",
    "licence": "3-1039585",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 6,
    "aidecreation_coprod": 88,
    "aidecreation_residence": 1,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 150,
    "diffusion_jp": 18,
    "diffusion_0_3ans": 5,
    "diffusion_3_6ans": 9,
    "diffusion_6_12ans": 4,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 4606,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": "44026 44109 44114 44143 44162",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400404,
    "actionculturelle_commune": 44109,
    "coords": [
      47.2125593,
      -1.5520298
    ]
  }
]
